{
  "dss": {
    "footer": {
      "legalEntity": "STIHL VERTRIEBS AG, 8617 Mönchaltorf"
    },
    "link": {
      "contact": "https://support.stihl.com/it-CH/websso-contact/",
      "faq": "https://support.stihl.com/it-CH/externalkbsearchwebsso/"
    },
    "page": {
      "postPwSet": {
        "link_name": "Torna al login",
        "link_url": "/user/ui/"
      }
    }
  }
}
